// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { FieldsFactory } from "../Factory/FieldsFactory.js"
import { MessageProcessorBase } from "./MessageProcessorBase.ts"
import { CommissionGroup, DirectMarginMessage } from "../../../../Utils/DirectMessages/DirectMarginMessage.js"
import { CommissionOperationType } from "../../../../Utils/Commission/CommissionOperationType.js"

export let MarginResponseMessageProcessor = function ()
{
    MessageProcessorBase.call(this)
}

MarginResponseMessageProcessor.prototype = Object.create(MessageProcessorBase.prototype)

MarginResponseMessageProcessor.prototype.decode = function (fieldSet)
{
    let message = new DirectMarginMessage();

    let factory = FieldsFactory

    let groups = fieldSet.GetGroups(factory.MARGIN_GROUP)

    for (let g = 0; g < groups.length; g++)
    {
        let group = groups[g],
            len = group.fieldSet.length,
            operationMode = group.GetValue(factory.FIELD_OPERATION_MODE),
            buySellSuffix = operationMode == CommissionOperationType.BUY ? 'Buy' : 'Sell';

        let commissionGroups = group.GetGroups(factory.COMMISSION_RESPONSE_GROUP)
        if (commissionGroups)
            message.CommissionsByOperationMode[operationMode] = this.parseCommissions(commissionGroups)

        let name = group.GetValue(factory.FIELD_NAME)
        if (name)  // buying power name #106952
            message.BuyingPowerName = name

        for (let i = 0; i < len; i++)
        {
            let fixField = group.fieldSet[i],
                fieldID = fixField.FieldId,
                fieldValue = fixField.Value;

            if (fieldID === 0)
                continue;

            switch (fieldID)
            {
                case factory.FIELD_BUY_INIT:
                    message.InitMarginBuy = fieldValue;
                    break
                case factory.FIELD_SELL_INIT:
                    message.InitMarginSell = fieldValue;
                    break
                case factory.FIELD_BUY_SUPP:
                    message.MaintMarginBuy = fieldValue;
                    break
                case factory.FIELD_SELL_SUPP:
                    message.MaintMarginSell = fieldValue;
                    break
                case factory.FIELD_WARN_MARGINGSIZE:
                    message.WarnMarginBuy = fieldValue;
                    break
                case factory.FIELD_WARN_MARGINGSIZE_SHORT:
                    message.WarnMarginSell = fieldValue;
                    break
                case factory.FIELD_SWAP_BUY:
                    message.SwapBuy = fieldValue;
                    break
                case factory.FIELD_SWAP_SELL:
                    message.SwapSell = fieldValue;
                    break
                case factory.FIELD_AVAILABLE_MARGIN:
                    message['AfterTradeFunds' + buySellSuffix] = fieldValue;
                    break;
            }
        }
    }

    return [message];
}


MarginResponseMessageProcessor.prototype.parseCommissions = function (commissionGroups)
{
    if (!commissionGroups)
        return

    let result = []

    for (let i = 0; i < commissionGroups.length; i++)
    {
        let group = commissionGroups[i]
        let resGroup = new CommissionGroup()

        resGroup.CommissionType = group.GetValue(FieldsFactory.FIELD_COMMISSION_TYPE)
        resGroup.OperationType = group.GetValue(FieldsFactory.FIELD_TYPE)
        resGroup.Amount = group.GetValue(FieldsFactory.FIELD_AMOUNT)
        resGroup.CurrencyId = group.GetValue(FieldsFactory.FIELD_ASSET_ID)

        result.push(resGroup)
    }

    return result
}